export default __webpack_public_path__ + "static/media/icon_policy_overview_step2-1.18c62053.svg";